import { Photo } from '@capacitor/camera';
import { Filesystem } from '@capacitor/filesystem';
import { Buffer } from 'buffer';

import { isRunningInNativeCapacitorApp } from 'src/util/platform/browserInteractionCapabilities';

export const readAsBase64 = async (photo: Photo) =>
	new Promise<string>((resolve) => {
		if (isRunningInNativeCapacitorApp()) {
			void Filesystem.readFile({
				path: photo.path as string,
			}).then((file) => {
				void convertBlobToBase64(base64ToBlob(file.data as string, `image/${photo.format}`)).then((result) => {
					resolve(result);
				});
			});
		} else {
			void fetch(photo.webPath as string).then((response) => {
				void response.blob().then((blob) => {
					void convertBlobToBase64(blob).then((result) => {
						resolve(result);
					});
				});
			});
		}
	});

export const convertBlobToBase64 = (blob: Blob) =>
	new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.onerror = reject;
		reader.onload = () => {
			resolve(reader.result as string);
		};
		reader.readAsDataURL(blob);
	});

export function blobToBase64(blob: Blob): Promise<string> {
	return new Promise((resolve) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			let base64Data = '';
			const result = reader.result as string;
			if (result !== null) {
				base64Data = result.split(',')[1];
			}
			resolve(base64Data);
		};
		reader.readAsDataURL(blob);
	});
}

function base64ToBlob(b64Data: string, contentType = '', sliceSize = 512) {
	const byteCharacters = Buffer.from(b64Data, 'base64').toString('binary');
	const byteArrays = [];

	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		const slice = byteCharacters.slice(offset, offset + sliceSize);

		const byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		byteArrays.push(byteArray);
	}

	return new Blob(byteArrays, { type: contentType });
}
